let loadPromise = null

// loadGoogleMaps injeta o SDK do Google Maps uma única vez (com as libraries drawing e
// geometry) e resolve quando google.maps.Map está disponível. Com loading=async o onload
// pode disparar antes das classes existirem, então fazemos polling do construtor.
export function loadGoogleMaps() {
  if (window.google?.maps?.Map) return Promise.resolve(window.google.maps)
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve, reject) => {
    const waitForMap = () => {
      let tries = 0
      const tick = () => {
        if (window.google?.maps?.Map) { resolve(window.google.maps); return }
        if (tries++ > 100) { reject(new Error('Google Maps não carregou')); return }
        setTimeout(tick, 50)
      }
      tick()
    }

    fetch('/api/config').then(r => r.json()).then(cfg => {
      if (!cfg.googleMapsApiKey) { reject(new Error('sem chave do Google Maps')); return }
      if (document.getElementById('gmaps-sdk')) { waitForMap(); return }
      const libs = cfg.mapsLibraries || 'geometry'
      const s = document.createElement('script')
      s.id = 'gmaps-sdk'
      s.src = `https://maps.googleapis.com/maps/api/js?key=${cfg.googleMapsApiKey}&libraries=${libs}&loading=async`
      s.async = true
      s.onload = waitForMap
      s.onerror = () => reject(new Error('falha ao carregar Google Maps'))
      document.head.appendChild(s)
    }).catch(reject)
  })
  return loadPromise
}

// GEOFENCE_COLORS: cor por tipo de cerca (paleta Volis).
export const GEOFENCE_COLORS = {
  boundary:   '#017f96',
  no_go:      '#f04438',
  restricted: '#f79009',
}

export function geofenceColor(kind, fallback) {
  return GEOFENCE_COLORS[kind] || fallback || '#017f96'
}

// --- Aerolevantamento (raster overlay) ---------------------------------------------
// Matemática slippy-map (Web Mercator) p/ clampar tiles aos limites do survey.
const tile2lon = (x, z) => x / 2 ** z * 360 - 180
const tile2lat = (y, z) => {
  const n = Math.PI - 2 * Math.PI * y / 2 ** z
  return 180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)))
}

// makeOrthoLayer cria um ImageMapType dos tiles processados de um mapa. gmaps é o
// namespace window.google.maps (o que loadGoogleMaps resolve). Servidos pelo backend
// (/api/maps/{id}/tiles/z/x/y.png). Se clamp e m.bounds existirem, tiles fora dos
// limites salvos viram transparentes (edição de limites = recorte do survey).
export function makeOrthoLayer(gmaps, m, { clamp = true } = {}) {
  const b = m.bounds || null
  const minZ = m.min_zoom ?? 0
  const maxZ = m.max_zoom ?? 22
  const ver = Date.parse(m.updated_at) || 0   // cache-buster: survey atualizado troca os tiles
  return new gmaps.ImageMapType({
    name: `ortho-${m.id}`,
    tileSize: new gmaps.Size(256, 256),
    minZoom: minZ,
    maxZoom: maxZ,
    opacity: 1,
    getTileUrl: (coord, zoom) => {
      if (zoom < minZ || zoom > maxZ) return null
      const n = 1 << zoom
      if (coord.x < 0 || coord.x >= n || coord.y < 0 || coord.y >= n) return null
      if (clamp && b && b.north != null) {
        const west = tile2lon(coord.x, zoom)
        const east = tile2lon(coord.x + 1, zoom)
        const north = tile2lat(coord.y, zoom)
        const south = tile2lat(coord.y + 1, zoom)
        if (east < b.west || west > b.east || south > b.north || north < b.south) return null
      }
      return `/api/maps/${m.id}/tiles/${zoom}/${coord.x}/${coord.y}.png${ver ? `?v=${ver}` : ''}`
    },
  })
}
